(function () {
  'use strict';

  function initCarousel(blockElement) {
    const splideElement = blockElement.querySelector('.carousel-block__splide');
    if (!splideElement) return;

    // Check if Splide is available - retry if not loaded yet
    if (typeof Splide === 'undefined') {
      setTimeout(function() {
        initCarousel(blockElement);
      }, 100);
      return;
    }

    // Avoid double init: destroy a previous instance if present
    if (splideElement.splideInstance && typeof splideElement.splideInstance.destroy === 'function') {
      splideElement.splideInstance.destroy();
      splideElement.splideInstance = null;
    }

    // Get settings from block data attributes or defaults
    const loopAttr = blockElement.dataset.loop !== 'false';
    const slidesPerViewMobile = parseInt(blockElement.dataset.slidesPerViewMobile) || 1;
    const slidesPerViewTablet = parseInt(blockElement.dataset.slidesPerViewTablet) || 2;
    const slidesPerViewDesktop = parseInt(blockElement.dataset.slidesPerViewDesktop) || 3;
    const spaceBetween = parseInt(blockElement.dataset.spaceBetween) || 24;
    const autoplay = blockElement.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(blockElement.dataset.autoplayDelay) || 3000;

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Wrap content_for blocks into slides if not already wrapped
    const listElement = splideElement.querySelector('.carousel-block__list');
    if (listElement) {
      const directChildren = Array.from(listElement.children).filter(child => 
        !child.classList.contains('splide__slide') &&
        child.tagName !== 'STYLE'
      );
      
      directChildren.forEach(function(child, index) {
        const slideWrapper = document.createElement('li');
        slideWrapper.className = 'splide__slide carousel-block__slide';
        slideWrapper.setAttribute('data-block-index', index);
        child.parentNode.insertBefore(slideWrapper, child);
        slideWrapper.appendChild(child);
      });
    }

    // Count real slides
    const getRealSlideCount = () => {
      const slides = splideElement.querySelectorAll('.splide__slide');
      return slides.length;
    };

    const realSlides = getRealSlideCount();

    // If slides are not in DOM yet, delay one frame
    if (realSlides === 0) {
      requestAnimationFrame(function() {
        initCarousel(blockElement);
      });
      return;
    }

    // Compute loop safely: need at least 2 real slides to loop
    const shouldLoop = loopAttr && !prefersReducedMotion && realSlides >= 2;

    // Build Splide options
    const splideOptions = {
      type: shouldLoop ? 'loop' : 'slide',
      perPage: slidesPerViewDesktop,
      perMove: 1,
      gap: spaceBetween + 'px',
      speed: prefersReducedMotion ? 1 : 600,
      pagination: false,
      arrows: false,
      keyboard: 'global',
      wheel: false,
      drag: true,
      snap: true,
      updateOnMove: true,
      flickMaxPages: 1,
      breakpoints: {
        1024: {
          perPage: slidesPerViewTablet,
          gap: spaceBetween + 'px',
        },
        768: {
          perPage: slidesPerViewMobile,
          gap: spaceBetween + 'px',
        },
      },
      ariaLabel: 'Carousel slider',
      role: 'region',
    };

    // Add autoplay if enabled
    if (autoplay && !prefersReducedMotion) {
      splideOptions.autoplay = true;
      splideOptions.interval = autoplayDelay;
      splideOptions.pauseOnHover = true;
      splideOptions.pauseOnFocus = true;
      splideOptions.resetProgress = false;
    }

    // Initialize Splide
    const splide = new Splide(splideElement, splideOptions);

    // Mount Splide
    splide.mount();

    // Handle custom navigation arrows
    const prevButtons = blockElement.querySelectorAll('.carousel-block__btn--prev');
    const nextButtons = blockElement.querySelectorAll('.carousel-block__btn--next');

    prevButtons.forEach(function (prevButton) {
      prevButton.addEventListener('click', function () {
        splide.go('<');
      });
    });

    nextButtons.forEach(function (nextButton) {
      nextButton.addEventListener('click', function () {
        splide.go('>');
      });
    });

    // Handle pagination if enabled
    const paginationElement = blockElement.querySelector('.carousel-block__pagination');
    if (paginationElement) {
      splide.on('pagination:mounted', function (data) {
        paginationElement.appendChild(data.list);
      });
    }

    // Store instance for potential cleanup and theme editor
    splideElement.splideInstance = splide;
  }

  function initAllCarousels() {
    const carouselBlocks = document.querySelectorAll('.theme-block-carousel');
    carouselBlocks.forEach(function(blockElement) {
      initCarousel(blockElement);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Reinitialize on section/block load (for Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const carouselBlocks = document.querySelectorAll('.theme-block-carousel');
      carouselBlocks.forEach(function(blockElement) {
        initCarousel(blockElement);
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      const carouselBlock = event.target.closest('.theme-block-carousel');
      if (carouselBlock) {
        setTimeout(function() {
          initCarousel(carouselBlock);
        }, 100);
      }
    });
  }
})();

